export const customErrorTypes = {};
